import { render, staticRenderFns } from "./PrintCorpHeader.vue?vue&type=template&id=fb94c3d2&scoped=true&"
import script from "./PrintCorpHeader.vue?vue&type=script&lang=js&"
export * from "./PrintCorpHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrintCorpHeader.vue?vue&type=style&index=0&id=fb94c3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb94c3d2",
  null
  
)

export default component.exports